var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBladderProtocol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6233 22.6491H4.37727C3.90927 22.6491 3.53027 22.2696 3.53027 21.8021V2.32159C3.53027 1.85409 3.90977 1.47559 4.37727 1.47559H19.6233C20.0913 1.47559 20.4698 1.85459 20.4698 2.32159V21.8016C20.4698 22.2696 20.0913 22.6491 19.6233 22.6491ZM5.22427 20.9551H18.7768V3.16909H5.22427V20.9551Z",
    fill: "#009BD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4964 15.0194H8.71988C8.25638 15.0194 7.87988 14.6434 7.87988 14.1789C7.87988 13.7149 8.25638 13.3389 8.71988 13.3389H15.4964C15.9594 13.3389 16.3364 13.7149 16.3364 14.1789C16.3364 14.6434 15.9594 15.0194 15.4964 15.0194Z",
    fill: "#009BD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4964 11.6312H8.71988C8.25638 11.6312 7.87988 11.2547 7.87988 10.7907C7.87988 10.3272 8.25638 9.95117 8.71988 9.95117H15.4964C15.9594 9.95117 16.3364 10.3272 16.3364 10.7907C16.3364 11.2547 15.9594 11.6312 15.4964 11.6312Z",
    fill: "#009BD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4964 8.24348H8.71988C8.25638 8.24348 7.87988 7.86748 7.87988 7.40398C7.87988 6.93948 8.25638 6.56348 8.71988 6.56348H15.4964C15.9594 6.56348 16.3364 6.93948 16.3364 7.40398C16.3364 7.86748 15.9594 8.24348 15.4964 8.24348Z",
    fill: "#009BD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6684 18.4004H8.85691C8.39691 18.4004 8.02441 18.0264 8.02441 17.5669C8.02441 17.1069 8.39691 16.7344 8.85691 16.7344H12.6684C13.1284 16.7344 13.5014 17.1069 13.5014 17.5669C13.5014 18.0264 13.1284 18.4004 12.6684 18.4004Z",
    fill: "#009BD4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBladderProtocol);
export default __webpack_public_path__ + "static/media/BladderProtocol.214e62ad7a75351cb2504426ac97cc1e.svg";
export { ForwardRef as ReactComponent };